import React from "react";
import styled from "styled-components";
import { deviceSize } from "../../components/responsive";
import Phone from "../../images/callcenter/WhoWeStaffIcon.png";
import Staff from "../../images/callcenter/WhereWeStaffIcon.png";
import Mstaff from "../../images/callcenter/HowWeStaffIcon.png";
import MedicalA from "../../images/callcenter/medicalH.png";

//MiddleSectionContainer
const MsC = styled.div`
  width: 100%;
  height: 1100px;
  background: linear-gradient(to bottom, #fcfcfb 2%, #ffffff 30%);
  margin-bottom: 0;
  /* magin-top: 5%; */
  @media screen and (max-width: 768px) {
    height: 1650px;
  }
`;


const ContextContianer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding-top: 5%;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 100%;
    flex-direction: column;
    height: 100%;
  }
`;

const QtHt = styled.h3`
  font-family: "Roboto";
  font-style: bold;
  font-weight: 400;
  font-size: 28px;
  line-height: 33px;
  margin-bottom: 60px;
  text-align: left;
  width: 60%;
  margin-left: 10%;
  color: #883fbc;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-right: 3%;
    width: 95%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 13px;
    width: 80%;
    text-align: left;
    margin-bottom: 3%;
    margin-left: 0px;
    padding-left: 10%;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    font-size: 0.9em;
    width: 80%;
    text-align: left;
  }
`;

//PerksWrap
const Pw = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 75%;
  height: 900px;
  flex-wrap: wrap;
  padding-left: 10%;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 14px;
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: nowrap;
    padding-left: 4%;
    height: 100%;
    margin-left: 0px;
  }
`;

//PerksContianer
const Pc = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 25%;
  height: 445px;
  margin-right: 5%;
  margin-bottom: 5%;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 10%;
  }

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 1.2em;
    margin-left: 0;
    padding-left: 7%;
    width: 90%;

    height: 420px;
  }

  @media screen and (max-width: ${deviceSize.mmobile}px) {
    font-size: 1em;
  }
`;

//PerksContianerImage
const PcI = styled.div`
  width: 65px;
  height: 63px;
  align-items: left;
  margin-bottom: 20px;

  @media screen and (max-width: 768px){
    display: flex;
  }
`;

//perks header one
const Ph = styled.h3`
  text-align: left;
  color: black;
  font-size: 18px;
  font-family: "Roboto", sans-serif;
  font-weight: 420;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 12px;
  }
`;

const Pp = styled.p`
  font-family: "Sunflower";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 25px;
  text-align: left;
  margin-top: 15px;
  color: #454545;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    font-size: 0.6em;
    width: 90%;

  }
`;

// const Al = styled.div`
//   width: 100%;
//   height: 600px;
//   display: flex;
//   flex-direction: row;

//   @media screen and (max-width: ${deviceSize.mobile}px) {
//     font-size: 0.9em;
//     width: 99%;
//     height: 500px;
//     list-style-type: disc;
//   }

//   @media screen and (max-width: ${deviceSize.slaptop}px) {
//     height: 300px;
//   }
// `;

const Pu = styled.ul`
  padding-left: 0;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 768px) {
    margin-left: 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;

  }
`;

const Pl = styled.li`
  font-family: "Sunflower";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  text-align: left;
  list-style-type: disc;
  width: 100%;
  color: #454545;

  @media screen and (max-width: ${deviceSize.slaptop}px) {
    margin-left: 0;
    width: 50%;
    /* display: flex; */
    /* flex-direction: column; */
    /* flex-wrap: wrap; */
  }

  @media screen and (max-width: 768px) {
    /* width: 40%; */
    /* height: 20px; */
    white-space: pre-line;
    list-style-type: disc;
    font-size: 0.8em;
    width: 100%;
  }
`;

const Img = styled.img`
  height: 53px;
  padding-right: 0;
  align-items: left;

  @media screen and (max-width: ${deviceSize.mobile}px) {
    width: 32.19px;
    height: 30.94px;
  }
`;

export function MiddleSectionContactUs() {
  return (
    <MsC>
      <ContextContianer id="context-container">
        <QtHt>A comprehensive range of support solutions.</QtHt>
        <Pw id="pw">
          <Pc id="pc">
            <PcI>
              <Img src={Phone} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Who We Staff</Ph>

            {/* <Al> */}
              <Pu>
                <Pl>Call Center Agents</Pl>
                <Pl> Customer Service Agents</Pl>
                <Pl> Order Processing Agents </Pl>
                <Pl>Bilingual Agents</Pl>
                <Pl>Shift Supervisors</Pl>
                <Pl>Team Leads</Pl>
                <Pl>Trainers</Pl>
              </Pu>
            {/* </Al> */}
          </Pc>

          <Pc>
            <PcI>
              <Img src={Staff} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Where We Staff</Ph>

            {/* <Al> */}
              <Pu>
                <Pl>Private Sector</Pl>
                <Pl>Public Sector</Pl>
                <Pl>NYC Agencies</Pl>
                <Pl>NY State Agencies</Pl>
              </Pu>
            {/* </Al> */}
          </Pc>

          <Pc>
            <PcI>
              <Img src={Mstaff} alt="computer with waring sign" />
            </PcI>
            <Ph>How we staff</Ph>
            <Pp>
              Magic! Well, not exactly. We simply strive to understand what
              matters to you and your customers. Exp Staffing creates a
              customized assessment, interview, and selection process that
              produces agents capable of delivering what matters most— high call
              volume while maintaining standards of quality, respect, and
              customer service.
            </Pp>
          </Pc>

          <Pc>
            <PcI>
              <Img src={MedicalA} alt="person in a hat who we hire" />
            </PcI>
            <Ph>Medical Call Agents</Ph>

            {/* <Al> */}
              <Pu>
                <Pl>Appeal Intake Agents</Pl>
                <Pl>Appeal Follow Up Support</Pl>
                <Pl>Revenue Cycle Specialists</Pl>
                <Pl>Insurance Provider Specialists</Pl>
                <Pl>Underpayment Efficiency Specialists</Pl>
              </Pu>
            {/* </Al> */}
          </Pc>
        </Pw>
      </ContextContianer>
    </MsC>
  );
}
